package com.upcominds.expedite.data.user

import com.upcominds.expedite.data.NetworkClient
import com.upcominds.expedite.dto.SocialAccountCreateRequest
import com.upcominds.expedite.dto.SocialAccountDTO
import com.upcominds.expedite.dto.SocialAccountVerificationCompleteRequest
import com.upcominds.expedite.dto.SocialAccountVerificationStartDTO
import com.upcominds.expedite.model.User
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.get
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.contentType

class UserRepositoryImpl : UserRepository {

    private val httpClient: HttpClient = NetworkClient.httpClient

    override suspend fun getCurrentUser(): User {
        return httpClient.get(NetworkClient.endpoint("api/users/me")).body<User>()
    }

    override suspend fun getSocialAccounts(): List<SocialAccountDTO> {
        return httpClient.get(NetworkClient.endpoint("api/profile/social-accounts")).body<List<SocialAccountDTO>>()
    }

    override suspend fun upsertSocialAccount(request: SocialAccountCreateRequest): SocialAccountDTO {
        return httpClient.post(NetworkClient.endpoint("api/profile/social-accounts")) {
            contentType(ContentType.Application.Json)
            setBody(request)
        }.body<SocialAccountDTO>()
    }

    override suspend fun startSocialAccountVerification(accountId: String): SocialAccountVerificationStartDTO {
        return httpClient.post(NetworkClient.endpoint("api/profile/social-accounts/$accountId/start-verification")) {
            contentType(ContentType.Application.Json)
        }.body<SocialAccountVerificationStartDTO>()
    }

    override suspend fun completeSocialAccountVerification(
        accountId: String,
        request: SocialAccountVerificationCompleteRequest
    ): SocialAccountDTO {
        return httpClient.post(NetworkClient.endpoint("api/profile/social-accounts/$accountId/complete-verification")) {
            contentType(ContentType.Application.Json)
            setBody(request)
        }.body<SocialAccountDTO>()
    }

}
